import { render, staticRenderFns } from "./rubric_share_modal.vue?vue&type=template&id=345e447c&scoped=true&"
import script from "./rubric_share_modal.vue?vue&type=script&lang=js&"
export * from "./rubric_share_modal.vue?vue&type=script&lang=js&"
import style0 from "./rubric_share_modal.vue?vue&type=style&index=0&id=345e447c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e447c",
  null
  
)

export default component.exports